var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-modal",
    {
      attrs: {
        size: "md",
        title: _vm.title,
        "modal-class": "vue-need-bootstrap",
        "title-class": "font-weight-bold",
        lazy: "",
        centered: "",
      },
      on: {
        ok: function ($event) {
          return _setup.emit("ok")
        },
        cancel: function ($event) {
          return _setup.emit("cancel")
        },
        close: function ($event) {
          return _setup.emit("cancel")
        },
      },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function ({ ok, cancel }) {
            return [
              _c(
                "div",
                { staticClass: "d-flex justify-content-between w-100" },
                [
                  _c(_setup.CButton, {
                    class: { invisible: _vm.hideCancel },
                    attrs: { text: "Cancel", variant: "secondary" },
                    on: { click: cancel },
                  }),
                  _vm._v(" "),
                  _c(_setup.CButton, {
                    attrs: { text: _vm.actionVerb, variant: "primary" },
                    on: { click: ok },
                  }),
                ],
                1
              ),
            ]
          },
        },
      ]),
      model: {
        value: _setup.isOpen,
        callback: function ($$v) {
          _setup.isOpen = $$v
        },
        expression: "isOpen",
      },
    },
    [
      _vm._t("modal-content", function () {
        return [_vm._v("\n        " + _vm._s(_vm.description) + "\n    ")]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }